// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","large":"Loading_large__MegFl","ball":"Loading_ball__Ny5az","bounce":"Loading_bounce__F5vi8"};